/**
 * 身份证匹配
 */
export function idCardRegex(idCardNum){
    const rex =  /(11|12|13|14|15|21|22|23|31|32|33|34|35|36|37|41|42|43|44|45|46|50|51|52|53|54|61|62|63|64|65|71|81|82|83)\d{4}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]/
    return rex.test(idCardNum)
}

/**
 * 字母加数字(可以全数字或全字母)
 * @returns {boolean}
 */
export function letterAndNumRegex(str) {
    const reg = /^[0-9a-zA-Z]{4,23}$/
    return reg.test(str)
}

export function usccRegex(usccNum) {
    const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
    return reg.test(usccNum)
}

/**
 * 验证电话号码
 * @param phone
 * @returns {boolean}
 */
export function phoneRegex(phone) {
    const reg = /^1[3456789]\d{9}$/
    return reg.test(phone)
}

/**
 * 验证邮政编码
 * @param emailNum
 * @returns {boolean}
 */
export function emailNumRegex(emailNum) {
    const reg = /^(?:[0-9]|[1-9][0-9]|[1-9][0-9]{2})$/
    return reg.test(emailNum)
}

/**
 * 证件号码相关验证（包含数字和字母，可全数字或全字母）
 * @param companyNum
 * @returns {boolean}
 */
export function cardNumRegex(companyNum) {
    const reg = /^\w\w\d{6}\w{9}\w$/;
    return reg.test(companyNum)
}

/**
 *  邮箱校验
 * @param companyNum
 * @returns {boolean}
 */
export function emailRegex(email) {
    const reg = /^[\w\-]+@[a-zA-Z\d\-]+(\.[a-zA-Z]{2,8}){1,2}$/;
    return reg.test(email)
}


/**
 *  出生医学证明编号
 * @param birthdayNum
 * @returns {boolean}
 */
export function birthdayNum(num) {
    const reg =  /^[a-zA-Z]\w{4,}$/;
    return reg.test(num)
}
